// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@steiner/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { tableStyles } from "@steiner/App/Widgets/CustomerPartNumbers/CustomerPartNumbersTable";
import Copy from "@steiner/XDL/Icons/Copy";
import { css } from "styled-components";

tableStyles.centeringWrapper = {
    css: css`
        min-height: 200px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};

tableStyles.downloadLinksWrapper = {
    css: css`
        display: flex;
        justify-content: end;
        gap: 12px;
        margin-top: 12px;
        margin-bottom: 12px;
    `,
};

tableStyles.csvFileLink = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
    icon: {
        position: "left",
        iconProps: {
            src: Copy,
            size: 14,
            css: css`
                margin-right: 6px;
            `,
        },
    },
};

tableStyles.textFileLink = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
    icon: {
        position: "left",
        iconProps: {
            src: Copy,
            size: 14,
            css: css`
                margin-right: 6px;
            `,
        },
    },
};

tableStyles.dataTable = {
    ...dataTableStyles.dataTable,
};

tableStyles.notFoundMessage = {
    ...dataTableStyles.noResultsText,
};
